/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebphotosnone3Inputs */

const en_placewebphotosnone3 = /** @type {(inputs: Placewebphotosnone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No photos selected. You can upload some later.`)
};

const de_placewebphotosnone3 = /** @type {(inputs: Placewebphotosnone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Fotos ausgewählt. Du kannst später welche hochladen.`)
};

/**
* | output |
* | --- |
* | "No photos selected. You can upload some later." |
*
* @param {Placewebphotosnone3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebphotosnone3 = /** @type {((inputs?: Placewebphotosnone3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebphotosnone3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebphotosnone3(inputs)
	return de_placewebphotosnone3(inputs)
});
export { placewebphotosnone3 as "placeWebPhotosNone" }